<template>
    <div class="kt-portlet__head">
        <div v-if="!$root.isMobile">
            <form class="isprint-filter" autocomplete="off">
                <div class="form-group mr-2">
                    <label>Denominazione</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione" type="text" v-model="search.DENOMINAZIONE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Stato Scadenza:</label><br>
                    <select class="form-control form-control-sm" v-model="search.STATO_SCADENZA.VALUE">
                        <option value="">Tutti</option>
                        <option value="Valido">Valido</option>
                        <option value="In scadenza domani">Domani</option>
                        <option value="In scadenza entro una settimana">7 giorni</option>
                        <option value="In scadenza entro 30 giorni">30 giorni</option>
                        <option value="In scadenza entro 60 giorni">60 giorni</option>
                        <option value="Scaduto">Scaduto</option>
                    </select>
                </div>
                <div class="form-group mr-2">
                    <label>Data Scadenza Da</label><br>
                    <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px" v-model="search.DATA_SCADENZA.VALUE_FROM"></DatePicker>
                </div>
                <div class="form-group mr-2">
                    <label>Data Scadenza A</label><br>
                    <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px" v-model="search.DATA_SCADENZA.VALUE_TO"></DatePicker>
                </div>
                <button class="btn btn-success float-right btn-sm my-2 my-sm-3" @click="creaScadenza()">
                    <i class="far fa-calendar-plus"></i> Crea Scadenza
                </button>
                <button class="btn btn-danger float-right btn-sm my-2 my-sm-3" @click="eliminaSelezionati()">
                    <i class="far fa-trash-alt"></i> Elimina selezionati
                </button>
                
            </form>
        </div>
        <div v-else>
            <div class="d-flex justify-content-center mt-3">
                <button class="btn btn-primary btn-sm mr-2" @click="toggleFilterSidebar">
                    <i class="fas fa-filter"></i> Filtri
                </button>
                <button class="btn btn-success btn-sm" @click="creaScadenza">
                    <i class="far fa-calendar-plus"></i> Crea Scadenza
                </button>
            </div>
            <div v-if="$root.isMobile" class="sidebar" :class="{ 'sidebar-open': isFilterSidebarOpen }">
                <div class="sidebar-header">
                    <h5>Filtri</h5>
                    <button type="button" class="close" @click="toggleFilterSidebar">&times;</button>
                </div>
                <div class="sidebar-body">
                    <form class="isprint-filter" autocomplete="off">
                        <div class="form-group">
                            <label>Denominazione</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione" type="text" v-model="search.DENOMINAZIONE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Stato Scadenza:</label><br>
                            <select class="form-control form-control-sm" v-model="search.STATO_SCADENZA.VALUE">
                                <option value="">Tutti</option>
                                <option value="Valido">Valido</option>
                                <option value="In scadenza domani">Domani</option>
                                <option value="In scadenza entro una settimana">7 giorni</option>
                                <option value="In scadenza entro 30 giorni">30 giorni</option>
                                <option value="In scadenza entro 60 giorni">60 giorni</option>
                                <option value="Scaduto">Scaduto</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Data Scadenza Da</label><br>
                            <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text" v-model="search.DATA_SCADENZA.VALUE_FROM"></DatePicker>
                        </div>
                        <div class="form-group">
                            <label>Data Scadenza A</label><br>
                            <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text" v-model="search.DATA_SCADENZA.VALUE_TO"></DatePicker>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="isprint-grid-container">
        <table v-if="!$root.isMobile" class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="background:#779774 ;color:#fff">
                    <th style="width:5%"><span>Sel.</span></th>
                    <th style="width:25%"><span>Denominazione Cliente</span></th>
                    <th style="width:20%"><span>Data Scadenza / Stato</span></th>
                    <th style="width:35%"><span>Note</span></th>
                    <th style="width:10%"><span>Lavorazione</span></th>
                    <th style="width:5%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr v-for="scadenza in paginatedListScadenze.arr" :key="scadenza.ID_SCADENZA" style="height:50px">
                    <td style="width:5%;">
                        <input type="checkbox" style="width:20px;height:20px" v-model="scadenza.SELEZIONATO" v-bind:true-value="1" v-bind:false-value="0">
                    </td>
                    <td style="width:25%;font-size:16px;font-weight:bold">
                        <span class="badge cliente" style="font-size:17px" v-on:click="apriCliente(scadenza.FK_ID_CLIENTE)">
                            <i class="fa fa-user" v-show="scadenza.TIPOLOGIA_CLIENTE == 1"></i>
                            <i class="fa fa-building" v-show="scadenza.TIPOLOGIA_CLIENTE == 2"></i>
                            <i class="fa fa-industry-alt" v-show="scadenza.TIPOLOGIA_CLIENTE == 3"></i>
                            {{ scadenza.DENOMINAZIONE }}
                        </span>
                    </td>
                    <td style="width:20%">
                        <span :class="badgeClass(scadenza.STATO_SCADENZA)" style="font-size:17px">
                            <i class="fad fa-calendar-exclamation"></i> {{ filters.formatDate(scadenza.DATA_SCADENZA) }}
                            {{ scadenza.STATO_SCADENZA }}
                        </span>
                    </td>
                    <td style="width:35%;">
                        <i class="fad fa-sticky-note"></i> 
                        {{ scadenza.NOTE == '' ? 'Scadenzario appena aggiunto' : scadenza.NOTE }}
                        <span v-if="scadenza.DATA_SCADENZA === '1901-01-01'" style="font-size: 14px; margin-left: 10px;">
                            (Scaduta per mancanza di "DATA_SCADENZA" nel flusso di importazione)
                        </span>
                    </td>
                    <td style="width:10%;">
                        <ISwitch @toggle="updateLavorazione(scadenza)" :size="'sm'" v-model="scadenza.FLG_LAVORATO" style="margin-top:6px"></ISwitch>
                    </td>
                    <td style="width:5%">
                        <div class="btn-group float-right" role="group">
                            <button class="btn btn-warning btn-sm" @click="modificaScadenza(scadenza)">
                                <i class="fal fa-pencil"></i>
                            </button>
                            <button v-show="scadenza.FLG_LAVORATO == 1" class="btn btn-danger btn-sm" @click="deleteScadenza(scadenza)">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="$root.isMobile">
            <div class="card mb-3" v-for="scadenza in paginatedListScadenze.arr" :key="scadenza.ID_SCADENZA">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="badge cliente" style="font-size:17px" v-on:click="apriCliente(scadenza.FK_ID_CLIENTE)">
                            <i class="fa fa-user" v-show="scadenza.TIPOLOGIA_CLIENTE == 1"></i>
                            <i class="fa fa-building" v-show="scadenza.TIPOLOGIA_CLIENTE == 2"></i>
                            <i class="fa fa-industry-alt" v-show="scadenza.TIPOLOGIA_CLIENTE == 3"></i>
                            {{ scadenza.DENOMINAZIONE }}
                        </span>
                    </h5>
                    <p class="card-text">
                        <strong>Data Scadenza:</strong> {{ filters.formatDate(scadenza.DATA_SCADENZA) }}<br />
                        <strong>Stato:</strong> {{ scadenza.STATO_SCADENZA }}<br />
                        <strong>Note:</strong> {{ scadenza.NOTE == '' ? 'Scadenzario appena aggiunto' : scadenza.NOTE }}<br />
                    </p>
                    <ISwitch @toggle="updateLavorazione(scadenza)" :size="'sm'" v-model="scadenza.FLG_LAVORATO"></ISwitch>
                    <div class="btn-group float-right">
                        <button class="btn btn-warning btn-sm mr-2" @click="modificaScadenza(scadenza)">
                            <i class="fal fa-pencil"></i>
                        </button>
                        <button v-show="scadenza.FLG_LAVORATO == 1" class="btn btn-danger btn-sm" @click="deleteScadenza(scadenza)">
                            <i class="fal fa-trash-alt"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListScadenze.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>
    <PopUpCliente :clienteSelezionato="clienteSelezionato" :arrayTipologiaListe="arrayTipologiaListe" @salva-cliente="salvaCliente" ref="popUpCliente" />
    <div class="modal fade" id="popUpScadenza" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog" :class="{'modal-lg': !$root.isMobile, 'modal-fullscreen': $root.isMobile}">
            <div class="modal-content">
                <div class="modal-header" style="background:#629991">
                    <h4 class="modal-title" style="color:#fff"><i class="fal fa-calendar-plus fa-fw"></i> Scadenza</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label>Seleziona Cliente:</label>
                            <Select2 v-model="scadenzaSelezionata.FK_ID_CLIENTE" :w="180" :api="getClientiApiUrl()" :apiselected="'es/cliente/s2'"></Select2>
                            
                        </div>
                        <div class="form-group col-md-4">
                            <label>Data Scadenza:</label>
                            <DatePicker placeholder="data scadenza" autocomplete="off" :dim="'sm'" type="text" style="width:100%" v-model="scadenzaSelezionata.DATA_SCADENZA"></DatePicker>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Note</label>
                            <textarea class="form-control form-control-sm" rows="5" v-model="scadenzaSelezionata.NOTE"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success" @click="salvaScadenza()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import Select2 from '../components/utils/Select2.vue';
import ISwitch from '../components/utils/ISwitch.vue';
import PopUpCliente from '../components/PopUpCliente.vue';
import { utils } from '../assets/js/utils';


export default {
    name: "Scadenze",
    components: {
        Pagine,
        DatePicker,
        Select2,
        ISwitch,
        PopUpCliente
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                ID_SCADENZA: { TYPE: 'TEXT', VALUE: '' },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                DATA_SCADENZA: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                STATO_SCADENZA: { TYPE: 'COMBO', VALUE: '' },

            },
            searchGestioneListe: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' }
            },
            arrayTipologiaListe: [],
            arrayScadenze: [],
            clienteSelezionato: { personaFisica: {}, personaGiuridica: {}, scadenze: [], contratti: [] },
            scadenzaSelezionata: {},
            dataModificata: '',
            isFilterSidebarOpen : false
        }
    },
    methods: {
        getClientiApiUrl() {
        const isGod = this.$root.isGod ? 1 : 0; 
        const idUtente = this.$root.utente.ID_UTENTE;
        return `es/cliente/select2?isGod=${isGod}&idUtente=${idUtente}`;
    },
        toggleFilterSidebar() {
            this.isFilterSidebarOpen = !this.isFilterSidebarOpen;
        },
        apriCliente(idCliente) {
            this.$refs.popUpCliente.getCliente(idCliente)
            this.$refs.popUpCliente.openPopUp();
        },
        salvaCliente(cliente) {
            if (cliente.ID_CLIENTE > 0) {
                global.utils.put('/es/cliente', cliente, (response) => {
                    if (response.esito === 0) {
                        utils.alert.success(response.messaggio);
                        this.getScadenze();
                        this.$refs.popUpCliente.closePopUp();
                    }
                });
            } else {
                global.utils.post('/es/cliente', cliente, (response) => {
                    if (response.esito === 0) {
                        utils.alert.success(response.messaggio);
                        this.getScadenze();
                        this.$refs.popUpCliente.closePopUp();
                    }
                });
            }
        },
        badgeClass(stato) {
            switch (stato) {
                case 'In scadenza entro 30 giorni':
                    return 'badge badge-warning';
                case 'Scaduto':
                    return 'badge badge-danger';
                case 'In scadenza domani':
                    return 'badge badge-alert-warning';
                case 'In scadenza entro una settimana':
                    return 'badge badge-third';
                case 'In scadenza entro 60 giorni':
                    return 'badge badge-info';
                case 'Valido':
                    return 'badge badge-success';
                default:
                    return 'badge badge-secondary';
            }
        },

        getScadenze: function () {
            global.utils.get('/es/scadenze', {isGod: this.$root.isGod, ID_UTENTE : this.$root.utente.ID_UTENTE}, (response) => {
                this.arrayScadenze = response.data;
            });
        },
        getTipologiaListe() {
            global.utils.get('/es/tipologialiste', {}, (response) => {
                this.arrayTipologiaListe = response.data; // Assicurati che sia un array
            });
        },
        creaScadenza: function () {
            this.scadenzaSelezionata = { ID_SCADENZA: 0, DATA_SCADENZA: this.filters.formatDate(new Date()), }
            var modal = utils.openModal('popUpScadenza');

        },
        modificaScadenza: function (scadenza) {
            this.scadenzaSelezionata = utils.clone(scadenza);
            this.scadenzaSelezionata.DATA_SCADENZA = filters.formatDate(scadenza.DATA_SCADENZA)
            var modal = utils.openModal('popUpScadenza');
        },

        modificaData: function (giorniDaSottrarre) {
            let data = new Date(filters.formatDateReverse(this.scadenzaSelezionata.DATA_SCADENZA))
            data.setDate(data.getDate() - giorniDaSottrarre)
            this.scadenzaSelezionata.DATA_SCADENZA = filters.formatDate(data.toISOString().split('T')[0])
        },
        deleteScadenza: function (scadenza) {
            utils.alert.confirm("Sei sicuro di voler eliminare la Scadenza selezionata?", () => {
                global.utils.delete('/es/scadenza', { ID_SCADENZA: scadenza.ID_SCADENZA }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getScadenze();
                    }

                });
            }, this.$root);
        },
        salvaScadenza: function () {
            if (this.scadenzaSelezionata.ID_SCADENZA > 0) {
                global.utils.put('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito == 0) {
                        this.getScadenze();
                        var modal = utils.closeModal('popUpScadenza')
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                global.utils.post('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito == 0) {
                        this.getScadenze()
                        var modal = utils.closeModal('popUpScadenza')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
        updateLavorazione: function (scadenza) {
            setTimeout(() => {
                utils.ajax('es/scadenza/update', scadenza, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        var modal = $('#popUpScadenza');
                        modal.modal('hide');
                    }
                });
            }, 250);
        },
        eliminaSelezionati : function(){
            var arr = utils.array.select(utils.filter(this.arrayScadenze,this.search),"SELEZIONATO",1);
            if (arr.length > 0){
                utils.alert.confirm("Sei sicuro di voler eliminare le scadenza selezionate?", () => {
                    global.utils.delete('es/scadenze', { arrayScadenze:arr }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getScadenze();
                    }

                });
                }, this.$root);
            }
        }
    },
    computed: {
        paginatedListScadenze() {
            if (!this.arrayScadenze || this.arrayScadenze.length === 0) return { arr: [], count: 0 };
            return utils.inGrid(this.arrayScadenze, this.search);
        },
        pageSize() {
            
            return this.$root.isMobile ? 15 : 50;
        }
    },
    watch: {
        
        pageSize(newSize) {
            this.search.PAGINATION.PAGE_SIZE = newSize;
        }
    },
    created: function () {
        this.getScadenze()
        this.getTipologiaListe()
        

    },
}
</script>
<style>
.badge.badge-third {
    background-color: #f06400ad;
    color: white;
    padding: 0.4em 0.7em;
    border-radius: 0.50rem;
    font-size: 0.875em;
    font-weight: 600;
}

.badge.badge-alert-warning {
    background-color: #e64622d2;
    color: white;
    padding: 0.4em 0.7em;
    border-radius: 0.25rem;
    font-size: 0.875em;
    font-weight: 600;
}
.grow {
    transition: all .2s ease-in-out;
}
.grow:hover {
    transform: scale(1.1);
}
.sidebar {
    position: fixed;
    top: 0;
    right: -300px;
    width: 220px !important;
    height: 100%;
    background-color: white;
    z-index: 1045;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    transition: right 0.3s ease;
}
.sidebar-open {
    right: 0;
    
}
.sidebar-header {
    padding: 10px;
    background-color: #779774 ;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.sidebar-body {
    padding: 20px;
}
.close {
    font-size: 24px;
    cursor: pointer;
}
.modal-content {
    background-color: #fff;
}

.bg-white-pers {
    background-color: whitesmoke;
    color: #4e73df;
}
@media (max-width: 768px) {
    .modal-fullscreen {
        width: 100%;
        max-width: 100%;
        height: 100%;
        margin: 0;
    }
}
</style>